import { CircularProgress } from "@mui/material";

export default function Loading() {
  return (
    <div id="loading" className="loadingDisabled">
      <CircularProgress color="primary" />
    </div>
  );
}